import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';
import { ROUTES } from '~/routes/routes';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Select, MenuItem } from '@mui/material';
import { DropdownArrow } from '~/views/atoms/svg-icons/dropdown-arrow';
import { ISupportMenu } from '~/views/types';
import { SupportMenuItem } from '~/views/enums';

export const SupportMenu: FC<ISupportMenu> = observer(props => {
    const selectedPage: SupportMenuItem = props.activeItem;
    const navigate = useNavigate();
    const onAccountPageChange = useCallback(() => {
        const path = selectedPage === SupportMenuItem.support ? ROUTES.MESSAGES.path : ROUTES.SUPPORT.path;
        navigate(path);
    }, [navigate]);

    return (
        <div className="account-menu support-menu">
            <h3>Support</h3>
            {false && (
                <div className="account-menu-inner">
                    <div className="account-menu-item">
                        <figure>
                            {props.activeItem === SupportMenuItem.support && <img src="/assets/img/faq-active.svg" />}
                            {props.activeItem !== SupportMenuItem.support && <img src="/assets/img/faq.svg" />}
                        </figure>
                        <Link
                            className={props.activeItem === SupportMenuItem.support ? 'account-active' : ''}
                            to={ROUTES.SUPPORT.path}
                        >
                            FAQ
                        </Link>
                    </div>
                    <div className="account-menu-item">
                        <figure>
                            {props.activeItem === SupportMenuItem.messages && (
                                <img src="/assets/img/messages-icon-active.svg" />
                            )}
                            {props.activeItem !== SupportMenuItem.messages && (
                                <img src="/assets/img/messages-icon.svg" />
                            )}
                        </figure>
                        <Link
                            className={props.activeItem === SupportMenuItem.messages ? 'account-active' : ''}
                            to={ROUTES.MESSAGES.path}
                        >
                            Messages center
                        </Link>
                    </div>
                </div>
            )}
            {false && (
                <div className="account-menu-select">
                    <Select
                        className="hr-select"
                        IconComponent={DropdownArrow}
                        value={selectedPage}
                        onChange={onAccountPageChange}
                    >
                        <MenuItem value={SupportMenuItem.support}>FAQ</MenuItem>
                        <MenuItem value={SupportMenuItem.messages}>Messages center</MenuItem>
                    </Select>
                </div>
            )}
        </div>
    );
});
